import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NoReviewsCard.css';

const NoReviewsCard = () => {
    const { t } = useTranslation();

    return (
      <div className="no-reviews-card">
        <h4>{t('noReviewsCardTitle')}</h4>
        <p>{t('noReviewsCardBody')}</p>
        <Link to="/" className="btn-upgrade">
            {t('successfullPaymentHome')}
            <i className="ph-arrow-circle-right ms-2"></i>
        </Link>
      </div>
    );
  };
export default NoReviewsCard;